import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import PageHeader from '../../components/common/PageHeader';
import transporteurService from '../../services/transporteurService';

function TransporteurLimits() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      const data = await transporteurService.getTransporteurs(search || undefined);
      setItems(data);
      setError(null);
    } catch (e) {
      setError(e.message || 'Failed to load transporteurs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const updateLimit = async (id, chauffeurLimit, vehiculeLimit) => {
    try {
      await transporteurService.updateTransporteurLimit(id, {
        chauffeurLimit: Number(chauffeurLimit ?? 0),
        vehiculeLimit: Number(vehiculeLimit ?? 0)
      });
      setItems(items.map(it => it.id === id ? { ...it, chauffeurLimit: Number(chauffeurLimit), vehiculeLimit: Number(vehiculeLimit) } : it));
    } catch (e) {
      setError(e.message || 'Failed to update limit');
    }
  };

  return (
    <DashboardLayout>
      <div className="container mt-3">
        <PageHeader title="Transporteur Limits" subtitle="Set chauffeur account limits per transporteur" />
        <div className="card">
          <div className="card-body">
            <div className="row g-2 mb-3">
              <div className="col-md-8">
                <input className="form-control" placeholder="Search by name, email or phone" value={search} onChange={e => setSearch(e.target.value)} />
              </div>
              <div className="col-md-4 d-flex gap-2">
                <button className="btn btn-outline-secondary w-50" onClick={() => { setSearch(''); load(); }}>Reset</button>
                <button className="btn btn-primary w-50" onClick={load}>Search</button>
              </div>
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            {loading ? (
              <div className="text-center"><div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead>
                    <tr>
                      <th>Enterprise</th>
                      <th>Contact</th>
                      <th>Current Limit (Chauffeurs)</th>
                      <th>Current Limit (Vehicles)</th>
                      <th className="text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map(t => (
                      <tr key={t.id}>
                        <td>
                          <div className="fw-semibold">{t.enterpriseName}</div>
                          <div className="text-muted small">{t.firstname} {t.lastname}</div>
                        </td>
                        <td>
                          <div>{t.email}</div>
                          <div className="text-muted small">{t.telephone}</div>
                        </td>
                        <td style={{ maxWidth: 160 }}>
                          <input type="number" min="0" className="form-control" value={t.chauffeurLimit ?? 0} onChange={e => setItems(items.map(it => it.id === t.id ? { ...it, chauffeurLimit: e.target.value } : it))} />
                        </td>
                        <td style={{ maxWidth: 160 }}>
                          <input type="number" min="0" className="form-control" value={t.vehiculeLimit ?? 0} onChange={e => setItems(items.map(it => it.id === t.id ? { ...it, vehiculeLimit: e.target.value } : it))} />
                        </td>
                        <td className="text-end">
                          <button className="btn btn-sm btn-primary" onClick={() => updateLimit(t.id, t.chauffeurLimit, t.vehiculeLimit)}>Save</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default TransporteurLimits;


